import {Injectable} from '@angular/core';
import {SecureApi} from '../core/secure.api';

@Injectable()
export class VerifyPatientRegistrationService {
    constructor(public secureApi: SecureApi) {
    }

    verify(data) {
        return this.secureApi.post('users/verify-patient-registration', data, false);
    }
}
